import './attachment.scss';

import Attachment from './Attachment';

export default Attachment;
